module.exports = __webpack_public_path__ + "img/happiest_workplace.418b7884.png";